import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { logEvent } from 'firebase/analytics';
import { getFirebaseAnalytics } from '../../firebase';

const Analytics = () => {
  const location = useLocation();

  useEffect(() => {
    getFirebaseAnalytics().then((analytics) => {
      if (!analytics) {
        return;
      }

      logEvent(analytics, 'page_view', {
        page_path: `${location.pathname}${location.search}`,
        page_location: window.location.href,
        page_title: document.title,
      });
    });
  }, [location.pathname, location.search]);

  return null;
};

export default Analytics;
